<template>
  <div id="table-column">
    <el-button v-if="tableData.bind" size="mini">{{tableData.bind}}</el-button>
    <el-tooltip v-if="tableData.icon" class="item" effect="dark" :content="tableData.helper" placement="top">
      <i :class="tableData.icon" size="mini" class="iconfont baogao" @click="btnClick(tableData,scope.row)"></i>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: "table-column",
  props: ["tableData", "scope"],
  data() {
    return {};
  },
  methods: {
    btnClick(btn, row) {
      if (btn.trigger) {
        btn.trigger(row, this);
      }
    }
  },
  mounted() {}
};
</script>
<style>
.baogao {
  font-size: 28px;
  color: rgba(151, 130, 249, 1);
  line-height: 29px;
}
.baogao:hover {
  color: #5ba9f6;
}
</style>
